module.exports = __webpack_public_path__ + "img/depositicon.3a57f06f.svg";